import { Row, SizedBox } from "../CommonBaseComponents";
import { C4Text } from "../text/CustomText";
import CustomDateSelectButton from "./CustomDateSelectButton";
import { useState } from "react";
import { Theme } from "../../Theme";

function CustomPeriodButton({ currentValue, setValue, values, hasCustom = false, openedCalendarLeftSide = false }) {
    const [currentCustomValue, setCurrentCustomValue] = useState("Custom");

    return (
        <SizedBox
            backgroundColor={Theme.color.neutral100}
            width={"auto"}
            height={"36px"}
            borderRadius={"8px"}
            overflow={"visible"}
        >
            <Row justifyContent={"space-between"} width={"100%"} padding={"0 3px"} gap={"6px"}>
                {values.map((v) => (
                    <SizedBox
                        padding={"0 12px"}
                        width={"auto"}
                        height={"30px"}
                        backgroundColor={currentValue === v.value ? Theme.color.white : "transparent"}
                        hoverBackgroundColor={currentValue === v.value ? undefined : Theme.color.zinc100}
                        borderRadius={"8px"}
                        border={currentValue === v.value ? `1px solid ${Theme.color.gray200}` : "none"}
                        cursor={"pointer"}
                        onClick={() => {
                            setValue(v.value);
                            setCurrentCustomValue("Custom");
                        }}
                    >
                        <C4Text fontColor={currentValue === v.value ? Theme.color.gray500 : Theme.color.gray400}>
                            {v.label}
                        </C4Text>
                    </SizedBox>
                ))}
                {hasCustom && (
                    <CustomDateSelectButton
                        currentValue={currentCustomValue}
                        setValue={(v) => {
                            setCurrentCustomValue(v);
                            setValue("Custom");
                        }}
                        values={["Custom"]}
                        openedCalendarLeftSide={openedCalendarLeftSide}
                    />
                )}
            </Row>
        </SizedBox>
    );
}

export default CustomPeriodButton;
